export interface StartingDataRow {
  material: string
  href: string
  insert: string
  speed: string
  doc: string
  feed: string
  source: string
}

export const startingDataColumns = [
  'Material / application',
  'Insert',
  'Speed',
  'DOC per side',
  'Feed',
  'Source condition / notes',
]

export const startingDataRows: StartingDataRow[] = [
  {
    material: '6061-T6 aluminum — roughing',
    href: '/applications/aluminum/',
    insert: 'APGX 331R MG12 or APGX 332R MG12',
    speed: 'No numeric SFM supplied',
    doc: '.050–.300 in',
    feed: '.025–.050 IPR',
    source: 'Recommended chip-control range on a 20 hp CNC lathe',
  },
  {
    material: '6061-T6 aluminum — lighter feeds',
    href: '/applications/aluminum/',
    insert: 'APGX 331-30R or APGX 332-30R (MG12 chipbreaker)',
    speed: 'No numeric SFM supplied',
    doc: '.015–.300 in',
    feed: '.010–.020 IPR',
    source: '-30R chipbreaker inserts for lighter feed rates in 6061-T6',
  },
  {
    material: 'Oxygen-free copper',
    href: '/applications/copper-soft-alloys/',
    insert: 'No insert part number specified',
    speed: '1,000 SFM',
    doc: 'Start at .050 in',
    feed: 'Start at .025 IPR',
    source: 'Peck cycle: .015 in feed, .010 in retract',
  },
  {
    material: 'Titanium',
    href: '/applications/titanium/',
    insert: 'APGX 331R DR80 or APGX 332R DR80',
    speed: '100–200 SFM',
    doc: 'Up to .400 in',
    feed: '.003–.007 IPR',
    source:
      'Suggested starting range; no specific alloy or test conditions supplied. Application-dependent.',
  },
]

export const startingDataNote =
  'Starting guidance only — not a guaranteed safe setting for any particular setup. Machine horsepower, workholding, part rigidity, tool overhang and machine limits govern actual parameters; reduce feed and depth of cut where required.'
